/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';

import {Logger} from '@/util/logger';
import {IProjectRow} from "@/screens/administration/i.project.row";
import {first} from "rxjs/operators";
import {ProjectService} from "@/services/project.service";
import {IOrganizationRow} from "@/screens/administration/i.organization.row";
import {Inplace} from "primeng/inplace";

@Component({
  standalone: false,
  templateUrl: 'my.projects.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

/**
 *
 * @class MyProjectsComponent
 *
 * @brief let the user view their own projects
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      August 2022
 *
 */
export class MyProjectsComponent implements OnInit {

  /** the projects where they are an administrator */
  public adminProjects: IProjectRow[]  = [];

  /** the user's memberships */
  public projects: IProjectRow[]       = [];

  /** the organizations where this user is an administrator */
  public adminOrgs: IOrganizationRow[] = [];

  /** the project key to use for creation */
  public prjCreateKey: string          = '';

  /** the project name to use for creation */
  public prjCreateName: string         = '';

  /** is the current key/project name valid for creating an project? */
  public prjInputValid: boolean        = false;

  /** the org selected in the org dropdown */
  public selectedOrg: number           = 0;

  /** standard constructor */
  constructor(
    private prjservice: ProjectService,
    private cdRef:      ChangeDetectorRef
  ) {

  }

  /** on page setup */
  ngOnInit() {

    Logger.debug('[MyProjectsComponent] init...');

    let mpc: MyProjectsComponent = this;

    mpc.refresh();
  }

  /** update ourselves when the project list deletes a project */
  projectDeleted(project: IProjectRow): void {

    let mpc: MyProjectsComponent = this;

    Logger.debug('[MyProjectsComponent] project deleted: ', project);

    mpc.refresh();
  }

  refresh() {

    let mpc: MyProjectsComponent = this;

    Logger.debug(`[MyProjectsComponent] looking for projects...`);

    mpc.prjservice.myProjects()
      .pipe(first())
      .subscribe({
        next: (data: any) => {

          mpc.projects      = [];
          mpc.adminProjects = [];
          mpc.adminOrgs     = [];

          if (data.result) {

            data = data.result;
          }

          data.admin_of.forEach((item) => {

            if (item.is_deleted) {

              return;
            }

            mpc.adminProjects.push(item);

          });

          mpc.adminProjects.sort((a: IProjectRow, b: IProjectRow) => {

            return a.name.localeCompare(b.name);
          });

          Logger.debug(`[MyProjectsComponent] admin projects: `, mpc.adminProjects);

          data.member_of.forEach((item) => {

            if (item.is_deleted) {

              return;
            }

            mpc.projects.push(item);

          });

          mpc.projects.sort((a: IProjectRow, b: IProjectRow) => {

            return a.name.localeCompare(b.name);
          });

          Logger.debug(`[MyProjectsComponent] projects: `, mpc.projects);

          data.admin_orgs.forEach((item) => {

            mpc.adminOrgs.push(item);
          });

          mpc.adminOrgs.sort((a: IOrganizationRow, b: IOrganizationRow) => {

            return a.name.localeCompare(b.name);
          });

          mpc.adminOrgs.unshift({
            id: 0,
            name: 'None',
            key: 'None'
          });

          Logger.debug(`[MyProjectsComponent] admin orgs: `, mpc.adminOrgs);

          /* tell Angular template to update */

          this.cdRef.detectChanges();
        },
        error: (error: any): void => {

          Logger.error(`[MyProjectsComponent] could not fetch projects: `, error);

        }

      });
  }

  /** check the "key" input for creating a project */
  checkKey(event = null) {

    let mpc: MyProjectsComponent = this;

    let name: string = $(`#createprojectlight`).val().toString().trim();
    let key: string = $(`#createprojectkeylight`).val().toString();

    /* clear the current error */

    mpc.prjInputValid = true;

    $(`.prjcreateerror`).html('');

    /* they have to pick an org */

    if (mpc.selectedOrg <= 0) {

      $(`.prjcreateerror`).html('Project must belong to an organization.');

      mpc.prjInputValid = false;

      mpc.cdRef.detectChanges();

      return false;
    }

    /* any validation issues? */

    if (!/^[a-zA-Z][_a-zA-Z0-9]+$/.test(key)) {

      $(`.prjcreateerror`).html('Project key must be of pattern [a-zA-Z][_a-zA-Z0-9]+');

      mpc.prjInputValid = false;

      mpc.cdRef.detectChanges();

      return false;
    }

    if (!name) {

      $(`.prjcreateerror`).html('Project name can not be empty.');

      mpc.prjInputValid = false;

      mpc.cdRef.detectChanges();

      return false;
    }

    if (event != null) {

      /* if it's a key up change, only trigger on RETURN */

      if (event.key == 'Enter') {

        mpc.createProject(true);
      }

    }

    /* clear to proceed! */

    mpc.cdRef.detectChanges();

    return true;
  }

  clearPicker() {

    let mpc: MyProjectsComponent = this;

    $(`#createprojectlight`).val('');
    $(`#createprojectkeylight`).val('');

    mpc.prjInputValid = false;
    mpc.selectedOrg   = 0;
  }

  createProject(noCheck: boolean  = false) {

    let mpc: MyProjectsComponent = this;
    let name: string              = $(`#createprojectlight`).val().toString();
    let key: string               = $(`#createprojectkeylight`).val().toString();
    let org: IOrganizationRow     = mpc.adminOrgs.find(x => x.id == mpc.selectedOrg);

    if (!noCheck) {

      /* we haven't checked the values yet */

      if (!mpc.checkKey()) {

        /* validation errors */

        return;
      }
    }

    mpc.clearPicker();

    Logger.debug(`[MyProjectsComponent] creating new project: '${name}', '${key}'...`);

    mpc.prjservice.create({name, key, rv_organizations_id: org.id})
      .pipe(first())
      .subscribe({

        next: (data: any) => {

          Logger.debug(`[MyProjectsComponent] project created, refreshing...`);

          mpc.refresh();

        },

        error: (data) => {

          let text: string = '';


          if (typeof data.message == 'string') {

            text = data.message;
          }

          if (typeof data.error.message == 'string') {

            text = data.error.message;
          }

          if (text.length != 0) {

            $(`.prjcreateerror`).html(text);

            mpc.prjInputValid = false;

          }

          Logger.error(`[MyProjectsComponent] could not create project: `, text);
        }

      });

  }

  /** set a new name for the given project */
  savePrjName(id: number, name: string) {

    let mpc: MyProjectsComponent = this;

    let prj: IProjectRow = mpc.projects.find(x => x.id == id);

    if (!prj) {

      return ;
    }

    /* update locally */

    prj.name = name;

    /* update the database... */

    mpc.prjservice.update(id, {name})
      .pipe(first())
      .subscribe({

        next: (data: any) => {

          /* refresh the list ... */

          mpc.refresh();

        },

        error: (error: any): void => {

          Logger.error(`[MyProjectsComponent] could not save new project name: `, error);

        }
      });

  }

  orgChange(event) {

    let mpc: MyProjectsComponent = this;

    Logger.debug("[ProjectsListComponent] new org: ", mpc.selectedOrg);

    mpc.checkKey();
  }

  prjEditKey(event, id: number, component: Inplace) {

    let mpc: MyProjectsComponent = this;
    let value: string = $(`.prjclass-${id} input`).val().toString();

    if (event.key != 'Enter') {

      return ;
    }

    Logger.debug(`[MyProjectsComponent] prj editor RETURN (${id}) => '${value}': `, event);

    mpc.savePrjName(id, value);

  }

  prjEditDeactivate(id: number, component: Inplace) {

    let mpc: MyProjectsComponent = this;
    let value: string = $(`.prjclass-${id} input`).val().toString();

    Logger.debug(`[MyProjectsComponent] deactivating prj editor (${id}) => '${value}': `, component);

    mpc.savePrjName(id, value);

  }

  prjEditActivate(id: number, component: Inplace) {

    let mpc: MyProjectsComponent = this;

    Logger.debug(`[MyProjectsComponent] activating prj editor (${id}): `, component);




  }
}

